export default __webpack_public_path__ + "static/media/app-showcase-image-03.ae7da91c.jpg";